/**
 * Hero trang /tai-app: giới thiệu app, banner mã giới thiệu, badge store, QR (desktop)
 * và ô đếm ngược trước khi tự chuyển sang store (chỉ khi link có ?ref= trên mobile).
 */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faApple, faGooglePlay } from "@fortawesome/free-brands-svg-icons";
import { faGift, faStar, faQrcode } from "@fortawesome/free-solid-svg-icons";
import { APP_LINKS, APP_QR_SRC } from "../../../constants/app-links";

/** Badge tải app kiểu 2 dòng (chuẩn App Store / Google Play). */
function StoreBadge({ href, icon, top, bottom }) {
    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 bg-black hover:bg-gray-900 text-white rounded-2xl pl-4 pr-6 py-2.5 active:scale-95 transition-all shadow-md"
        >
            <FontAwesomeIcon icon={icon} className="text-3xl" />
            <span className="flex flex-col leading-tight text-left">
                <span className="text-[10px] opacity-80">{top}</span>
                <span className="text-base font-bold -mt-0.5">{bottom}</span>
            </span>
        </a>
    );
}

export default function DownloadHeroSection({ refCode, countdown, onStay }) {
    return (
        <div className="relative overflow-hidden bg-gradient-to-br from-[#fad126] via-[#ff7a45] to-[#ff544f] text-white px-5 pt-8 pb-10 rounded-b-3xl text-center">
            {/* decor blobs */}
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-surface/15 rounded-full blur-2xl" />
            <div className="absolute -bottom-12 -left-8 w-44 h-44 bg-surface/10 rounded-full blur-2xl" />

            <div className="relative">
                {/* App icon */}
                <div className="mx-auto w-24 h-24 rounded-full bg-surface shadow-xl overflow-hidden flex items-center justify-center">
                    <img src="/img/brand-logo/longhousee.png" alt="Longhousee" className="w-full h-full object-cover" />
                </div>

                <h1 className="font-lexend text-2xl md:text-3xl font-extrabold mt-4">Tải App Longhousee</h1>
                <p className="text-white/95 text-sm md:text-base mt-1.5 max-w-md mx-auto">
                    Mua Shopee, Lazada, TikTok Shop, ShopeeFood qua App để nhận <strong>hoàn tiền đến 80%</strong> về ví — rút về ngân hàng từ 10.000đ.
                </p>
                <p className="text-white/95 text-sm md:text-base mt-1 max-w-md mx-auto">
                    Mua qua App còn được <strong>x2 hoàn tiền<sup>*</sup></strong>.
                </p>
                <p className="text-white/75 text-[11px] mt-1.5 max-w-md mx-auto">
                    *Áp dụng trong các đợt khuyến mãi theo cấu hình từng thời điểm.
                </p>

                {/* Rating strip */}
                <div className="flex items-center justify-center gap-1.5 mt-3 text-amber-200">
                    {[0, 1, 2, 3, 4].map((i) => (
                        <FontAwesomeIcon key={i} icon={faStar} className="text-xs" />
                    ))}
                    <span className="text-white/90 text-xs ml-1">Được hàng nghìn người dùng tin chọn</span>
                </div>

                {/* Banner mã giới thiệu — hiện khi link có ?ref= */}
                {refCode ? (
                    <div className="mt-5 mx-auto max-w-sm bg-surface/15 backdrop-blur rounded-2xl px-4 py-3 text-sm">
                        <FontAwesomeIcon icon={faGift} className="mr-2" />
                        Bạn được tặng mã giới thiệu <strong>{refCode}</strong> — tải app & đăng ký, mã sẽ <strong>tự điền</strong> cho bạn!
                    </div>
                ) : null}

                {/* Store badges */}
                <div className="flex flex-wrap justify-center gap-3 mt-6">
                    <StoreBadge href={APP_LINKS.ios} icon={faApple} top="Tải về trên" bottom="App Store" />
                    <StoreBadge href={APP_LINKS.android} icon={faGooglePlay} top="Tải về trên" bottom="Google Play" />
                </div>

                {/* Đếm ngược tự chuyển store — người mới bấm "Ở lại" để đọc thông tin bên dưới */}
                {countdown != null ? (
                    <div className="mt-4 mx-auto max-w-sm bg-black/20 rounded-2xl px-4 py-2.5 text-xs flex items-center justify-center gap-2 flex-wrap">
                        <span>Tự mở cửa hàng ứng dụng sau {countdown}s</span>
                        <button
                            type="button"
                            onClick={onStay}
                            className="underline font-semibold active:scale-95 transition-transform"
                        >
                            Ở lại xem thông tin
                        </button>
                    </div>
                ) : null}

                {/* QR — chỉ hiện desktop */}
                <div className="hidden md:flex flex-col items-center gap-2 mt-7">
                    <div className="bg-surface p-2.5 rounded-2xl shadow-lg">
                        <img src={APP_QR_SRC} alt="QR tải app Longhousee" width={120} height={120} className="rounded-lg" />
                    </div>
                    <span className="inline-flex items-center gap-1.5 text-white/90 text-xs">
                        <FontAwesomeIcon icon={faQrcode} />
                        Quét mã bằng điện thoại để tải
                    </span>
                </div>
            </div>
        </div>
    );
}
